import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';

import FormattersStore from '../stores/Formatters';

const styles = {
  cardContainer: {
    textAlign: 'start',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: 'small',
    borderRadius: 'medium',
    color: '#111111',
    fontSize: 'small',
    backgroundColor: 'white',
    width: '100%',
    gap: 'xlarge',
    border: '1px solid #E2E2E2',
    maxWidth: '577px'
  },
  cardDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'xxsmall'
  },
  duration: {
    fontSize: 'xsmall',
    color: '#444444'
  },
  cardLeftSection: {
    display: 'flex',
    gap: 'small'
  }
};

const AddonCardUI = ({ addOn, isSelected, handleAddonClick }) => {
  const {
    Block,
    Input: { Checkbox }
  } = UX2.Element;
  const { numberFormatter } = FormattersStore.getState();

  return (
    <Block style={ styles.cardContainer }>
      <Block style={ styles.cardLeftSection }>
        <Checkbox
          tag='input'
          type='checkbox'
          checked={ isSelected }
          onChange={ () => handleAddonClick(addOn.id) }
        />
        <Block style={ styles.cardDetails }>
          <Block>{ addOn.title }</Block>
        </Block>
      </Block>
      <Block> { numberFormatter.formatCurrency(+addOn.price) } </Block>
    </Block>
  );
};

AddonCardUI.propTypes = {
  addOn: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  handleAddonClick: PropTypes.func.isRequired
};

export default AddonCardUI;
